import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getIsFetchingActiveUser,
  getActiveUser,
  getAuthToken,
} from 'Store/reducers';

import Link from 'Components/Link';
import ConnectedFormattedImage from 'Containers/ConnectedFormattedImage';
import SiteNav from 'Components/SiteNav';
import { ROUTES } from 'Settings/route-strings';

import logoImg from './TinybopSchoolsLogo.png';
import FreeAccessAlert from './FreeAccessAlert';
import styles from './SiteHeader.scss';
import { withRouter } from 'react-router';

const stripSlashes = (str) => str.replace(/\//g, '');

const SiteHeader = ({
  isSticky,
  authToken,
  activeUser,
  isFetchingActiveUser,
  location,
}) => (
  <React.Fragment>
    <div className={`SiteHeader${isSticky ? ' is-sticky' : ''}`}>
      <div className="SiteHeader__container">
        <h1 className="SiteHeader__logo">
          <Link to={ROUTES.INDEX}>
            <ConnectedFormattedImage
              className="SiteHeader__logo-image"
              src={logoImg}
              altId="product.name"
            />
          </Link>
        </h1>
        <SiteNav />
      </div>
    </div>
  </React.Fragment>
);

SiteHeader.defaultProps = {
  isSticky: false,
};

SiteHeader.propTypes = {
  isSticky: PropTypes.bool,
  authToken: PropTypes.string,
  activeUser: PropTypes.object,
  isFetchingActiveUser: PropTypes.bool,
  location: PropTypes.object,
};

export default withRouter(
  connect((state) => ({
    isFetchingActiveUser: getIsFetchingActiveUser(state),
    activeUser: getActiveUser(state),
    authToken: getAuthToken(state),
  }))(SiteHeader)
);
